import React, { useState } from 'react';

import './Tooltip.css';

const TooltipDyn = React.forwardRef((props, ref) => {
  let timeout;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 200);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };
  return (
    <div
      className="wrapper-scroll"
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {props.children}
      {active && (
        <div
          style={props.style}
          ref={ref}
          id="tooltip"
          className={`tooltip-tip ${props.direction || 'top'}`}
        >
          {props.content}
        </div>
      )}
    </div>
  );
});

export default TooltipDyn;
